<template>
  <div>
    <div v-if="dataImages.length === 0 && !avatar" class="upload-image-box">
      <md-button
        class="md-success md-round md-fileinput"
        @click="showModalUploadImage('create')"
        :disabled="!isEditMode"
      >
        {{ $t("upload_image.add_image") }}
      </md-button>
    </div>
    <div v-else class="upload-multiple-images-container">
      <div class="station-avatar" v-if="avatar">
        <img :src="avatar" alt="" class="avatar-station-img" />
        <a
          href="javascript:void(0)"
          class="edit-avatar"
          @click="showAvatarActions()"
          v-if="isEditMode"
        >
          <md-icon>more_vert</md-icon>
        </a>
        <div class="image-box-shadow"></div>
        <div
          class="image-actions-box-shadow"
          v-if="displayAvatarActions"
          @click="showAvatarActions()"
        ></div>
        <ul class="image-actions" v-if="displayAvatarActions">
          <li>
            <a
              href="javascript:void(0)"
              @click="showModalUploadImage('changeAvatar')"
              ><md-icon class="set-avatar-icon">edit</md-icon>
              <p>
                {{ changeAvatarText }}
              </p>
            </a>
          </li>
        </ul>
        <p class="primary-text">
          <md-icon>check</md-icon>
          {{ primaryText }}
        </p>
      </div>
      <div class="multiple-images-box">
        <div
          class="station-image-box"
          v-for="(image, index) in dataImages"
          :key="'station-image-element' + index"
        >
          <img :src="image" alt="img" class="station-img" />
          <a
            href="javascript:void(0)"
            class="edit-image"
            @click="showActions(index)"
            v-if="isEditMode"
          >
            <md-icon>more_vert</md-icon>
          </a>
          <div class="image-box-shadow"></div>
          <div
            class="image-actions-box-shadow"
            v-if="displayActions && index === currentIndex"
            @click="showActions(index)"
          ></div>
          <ul
            class="image-actions"
            v-if="displayActions && index === currentIndex"
          >
            <!--            <li>-->
            <!--              <a href="javascript:void(0)" @click="setAvatar(index)"-->
            <!--                ><md-icon class="set-avatar-icon">photo</md-icon>-->
            <!--                <p>-->
            <!--                  {{ markIsPrimaryText }}-->
            <!--                </p>-->
            <!--              </a>-->
            <!--            </li>-->
            <li>
              <a href="javascript:void(0)" @click="removeImage(index)">
                <md-icon class="delete-image-icon">delete_forever</md-icon>
                <p>
                  {{ removeImgText }}
                </p>
              </a>
            </li>
          </ul>
        </div>
        <div
          class="btn-add-image-container"
          v-if="
            ((avatar && dataImages.length >= 0) ||
              (!avatar && dataImages.length > 0)) &&
              dataImages.length < maxImage &&
              isEditMode
          "
        >
          <a
            href="javascript:void(0)"
            class="btn-add-image"
            :title="addImageText"
            @click="showModalUploadImage('create')"
          >
            <md-icon>add</md-icon>
          </a>
        </div>
      </div>
    </div>
    <confirm-modal
      :modal-data="modalData"
      :confirm-text="confirmText"
      :btn-ok-text="btnOkText"
      :btn-cancel-text="btnCancelText"
      @closeModal="closeModal"
      @confirm="confirmOk"
    >
    </confirm-modal>
  </div>
</template>

<script>
import ConfirmModal from "../Modal/ConfirmModal";
import i18n from "../../lang/i18n";
export default {
  name: "VueUploadMultipleImage",
  components: { ConfirmModal },
  data() {
    return {
      displayActions: false,
      displayAvatarActions: false,
      currentIndex: null,
      modalData: {
        show: false,
        item: null
      },
      confirmText: null,
      btnOkText: null,
      btnCancelText: null
    };
  },
  props: {
    isEditMode: {
      type: Boolean,
      default: true
    },
    dataImages: {
      type: Array
    },
    avatar: {
      default: null
    },
    maxImage: {
      type: Number,
      default: 5
    },
    addImageText: {
      type: String,
      default: i18n.t("modal.add_image")
    },
    primaryText: {
      type: String,
      default: i18n.t("modal.is_avatar")
    },
    removeImgText: {
      type: String,
      default: i18n.t("modal.remove_image")
    },
    markIsPrimaryText: {
      type: String,
      default: i18n.t("modal.set_avatar")
    },
    changeAvatarText: {
      type: String,
      default: i18n.t("modal.change_avatar")
    },
    confirmSetAvatarText: {
      type: String,
      default: i18n.t("modal.confirm_set_avatar_text")
    },
    confirmRemoveImageText: {
      type: String,
      default: i18n.t("modal.confirm_remove_image_text")
    }
  },
  watch: {
    dataImages(newVal) {
      console.log(newVal);
    }
  },
  methods: {
    showModalUploadImage(action) {
      this.$store.commit("DESTROY_MODAL");
      this.$store.commit("SHOW_MODAL");
      this.displayActions = false;
      this.displayAvatarActions = false;
      this.$emit("showModalUploadImage", action);
    },
    showActions(index) {
      this.displayAvatarActions = false;
      if (this.currentIndex !== index && this.displayActions) {
        this.currentIndex = index;
      } else if (this.currentIndex !== index && !this.displayActions) {
        this.currentIndex = index;
        this.displayActions = !this.displayActions;
      } else {
        this.displayActions = !this.displayActions;
      }
    },
    showAvatarActions() {
      this.displayActions = false;
      this.displayAvatarActions = !this.displayAvatarActions;
    },
    removeImage(index) {
      this.displayActions = false;
      this.displayAvatarActions = false;
      this.modalData.show = true;
      this.modalData.item = {
        action: "removeImage",
        index: index
      };
      this.confirmText = this.confirmRemoveImageText;
      this.btnOkText = this.$t("modal.ok");
      this.btnCancelText = this.$t("modal.no");
    },
    setAvatar(index) {
      this.displayActions = false;
      this.modalData.show = true;
      this.modalData.item = {
        action: "setAvatar",
        index: index
      };
      this.confirmText = this.confirmSetAvatarText;
      this.btnOkText = this.$t("modal.ok");
      this.btnCancelText = this.$t("modal.no");
    },
    closeModal() {
      this.modalData.show = false;
    },
    confirmOk(modalData) {
      this.closeModal();
      if (!modalData || !modalData.item) {
        return;
      }
      this.$emit(modalData.item.action, modalData.item.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-multiple-images-container {
  display: grid;
  grid-template-columns: 45% 55%;
  column-gap: 20px;
}
.multiple-images-box {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
  height: min-content;
}
.avatar-station-img {
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 4px 3px 0 rgb(0 0 0 / 22%);
  -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 4px 3px 0 rgb(0 0 0 / 22%);
}
.btn-add-image i {
  background-color: #9c27b0;
  color: #fff !important;
  border-radius: 50%;
  font-size: 24px !important;
}
.btn-add-image-container {
  align-self: center;
  text-align: center;
}

.upload-image-box {
  text-align: center;
}

.station-avatar {
  position: relative;
  .edit-avatar {
    position: absolute;
    top: 5px;
    right: 0;
    border-radius: 50%;
    z-index: 2;
  }
  i {
    color: #fff !important;
  }
}
.primary-text {
  position: absolute;
  bottom: 5px;
  left: 10px;
  margin: 5px 0;
  font-size: 14px;
  font-weight: 600;
  background: #fff !important;
  border-radius: 5px;
  padding: 2px 5px;
  color: #373638;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 22%);
  -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 22%);

  i {
    background-color: #48a44c;
    border-radius: 50%;
    color: #fff !important;
    font-size: 14px !important;
    width: 18px;
    min-width: 18px;
    height: 18px;
  }
}

.station-image-box {
  position: relative;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 4px 3px 0 rgb(0 0 0 / 22%);
  -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 4px 3px 0 rgb(0 0 0 / 22%);
  min-height: 35px;
  background: #a6a6a6;
  .edit-image {
    position: absolute;
    top: 5px;
    right: 0;
    border-radius: 50%;
    z-index: 2;
  }
  i {
    color: #fff !important;
  }
}
.image-actions {
  position: absolute;
  top: 0;
  right: 25px;
  list-style: none;
  background: white;
  padding: 5px;
  border-radius: 2px;
  margin: 5px 0;
  z-index: 2;
  box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 4px 3px 0 rgb(0 0 0 / 22%);
  -webkit-box-shadow: 0 2px 2px 0 rgb(0 0 0 / 20%), 0 4px 3px 0 rgb(0 0 0 / 22%);
  li {
    background-color: #eeeeee;
    border-radius: 3px;
    padding: 3px;
    margin-bottom: 5px;
    p {
      font-weight: 600;
      margin: 0;
      color: #000;
    }
    i {
      color: black !important;
      font-size: 16px !important;
      width: 16px !important;
      min-width: 16px !important;
      height: 16px !important;
    }
    a {
      font-size: 12px !important;
      display: grid;
      grid-template-columns: 18px 1fr;
    }
  }
  li:hover {
    background-color: #eaf3ff;
    p {
      color: #000;
    }
  }
  li:last-child {
    margin-bottom: 0 !important;
  }

  .delete-image-icon {
    color: red !important;
  }

  .set-avatar-icon {
    color: #00acc1 !important;
  }
}
.image-actions-box-shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: #000;
  opacity: 0.2;
}

.image-box-shadow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background: transparent;
  opacity: 0.2;
}

.station-image-box:hover .image-box-shadow {
  background: #000;
  opacity: 0.2;
}

.station-avatar:hover .image-box-shadow {
  background: #000;
  opacity: 0.2;
}

@media all and (max-width: 768px) {
  .upload-multiple-images-container {
    grid-template-columns: 1fr;
    grid-row-gap: 20px;
  }
}
</style>
